import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { getApiUrl } from "../../services/api_service";

function Footer() {
  const [version, setVersion] = useState("...");
  const [releaseNotes, setReleaseNotes] = useState("");
  const [appName, setAppName] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetch(`${getApiUrl()}/appversion/dashboard`)
      .then((res) => res.json())
      .then((data) => {
        setVersion(data.version || "1.0.0");
        setReleaseNotes(data.releaseNotes || "");
        setAppName(data.appName || "EnrichMyCare Professional Dashboard");
      })
      .catch(() => {
        setVersion("1.0.0");
        setReleaseNotes("");
        setAppName("EnrichMyCare Professional Dashboard");
      });
  }, []);

  const handleVersionClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <footer style={{ textAlign: "center", padding: "10px" }}>
        <span
          style={{ cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
          onClick={handleVersionClick}
          title="Show release notes"
        >
          Version {version}
        </span>{" "}
        | &copy; Enrich Digital Technologies Ltd. - {dayjs().year()} . All rights reserved. Our{" "}
        <a target="_blank" href="https://www.enrichmycare.com/our-policies/#Terms" rel="noreferrer">
          Terms Of Service
        </a>{" "}
        and{" "}
        <a target="_blank" href="https://www.enrichmycare.com/our-policies/#Privacy" rel="noreferrer">
          Privacy Policy
        </a>
      </footer>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Release Notes</DialogTitle>
        <DialogContent>
          <div style={{marginBottom:"10px"}}>
            Version {version}
          </div>
          <div style={{ whiteSpace: "pre-line" }}>
            {releaseNotes ? releaseNotes : "No release notes available."}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Footer;